import { Box, Flex, HStack, Text, useRadioGroup } from '@chakra-ui/react';
import { RadioCard } from './RadioCard';

export type StorageProvider = 'local' | 'azure' | 'aws' | 'gcp' | 'previous';

interface StorageProviderSelectorProps {
    selectedProvider: StorageProvider;
    onChange: (provider: StorageProvider) => void;
    showPrevious?: boolean;  // Optional: show "Select from Previous" option
}

export const StorageProviderSelector = ({
    selectedProvider,
    onChange,
    showPrevious = false,
}: StorageProviderSelectorProps) => {
    const options: { value: StorageProvider; label: string; icon: string }[] = [
        { value: 'local', label: 'Local Upload', icon: '💻' },
        { value: 'azure', label: 'Azure ADLS', icon: '☁️' },
        { value: 'aws', label: 'AWS S3', icon: '📦' },
        { value: 'gcp', label: 'Google Cloud', icon: '🌐' },
        ...(showPrevious ? [{ value: 'previous' as StorageProvider, label: 'Previous Files', icon: '📁' }] : []),
    ];

    const { getRootProps, getRadioProps } = useRadioGroup({
        name: 'storageProvider',
        value: selectedProvider,
        onChange: (value) => onChange(value as StorageProvider),
    });

    const group = getRootProps();

    return (
        <Box mb={6}>
            <Text fontSize="lg" fontWeight="semibold" color="primary.500" mb={3} textAlign="center">
                Select Upload Method
            </Text>
            <Flex justify="center" align="center">
                <HStack {...group} spacing={3} flexWrap="wrap">
                    {options.map((option) => {
                        const radio = getRadioProps({ value: option.value });
                        return (
                            <RadioCard key={option.value} {...radio}>
                                <HStack spacing={2}>
                                    <Text fontSize="2xl" color="inherit">{option.icon}</Text>
                                    <Text fontWeight="medium" color="inherit">{option.label}</Text>
                                </HStack>
                            </RadioCard>
                        );
                    })}
                </HStack>
            </Flex>
        </Box>
    );
};
